import React from 'react';
import { connect } from 'react-redux';
import SearchArticleComponent from '../../../components/troubleShooting/search/SearchArticleComponent';
import { getPageDataAction } from '../../../store/troubleShooting/search/action';
import defaultState from '../../../store/defaultStore';
import { saveSearchOptionAction } from '../../../store/troubleShooting/search/action';
import ReactGA from 'react-ga4';

class SearchArticleContainer extends React.Component {
  constructor(props) {

    super(props);
   
    this.state = {
      pageData: [],
      disableSearchBtn: true,      
      FREETEXT_KEY: "free-text",
      CATEGORY_KEY: "category",
      searchOption: {
        keyword_search: (this.props.searchOption.search_key==='free-text') ? this.props.searchOption.search_value : '',
        category_search:  (this.props.searchOption.search_key==='category') ? this.props.searchOption.search_value : '',
        search_key: (this.props.searchOption.search_key) ? this.props.searchOption.search_key : '',
        search_value: (this.props.searchOption.search_value) ? this.props.searchOption.search_value : '',
        category_names: "",
      },
      subCategories: [],
      searchPlaceHolder:'default'
    }
    //this.onChangeHandler = this.onChangeHandler.bind(this);
    this.selectedCat = [];
    this.SubCateList = {
        options: {},
        selectedValue: '',
        selectedKey: ''
    };
    this.subCat = [];
    this.mainCategory = '';
    this.firstSelectedDropDownValue = '';
    this.onSubmitHandler = this.onSubmitHandler.bind(this);
  }

  /**
   * componentDidMount method to load pre needed data like page title, heading etc.
   */
  componentDidMount() {
    this.props.getPageData();
  }
  /**
 * componentDidMount method to load pre needed data like page title, heading etc.
 */
  componentWillMount() {
   
   
    if (this.props.searchOption) {
      
      this.setState({
        searchOption: { ...this.state.searchOption, search_value: this.props.searchOption.search_value, search_key: this.props.searchOption.search_key }

      });
    }
    


  }

  /**
   * @method: Submit Handler onSubmitHandler to perform search operation
   * @input: search_key & search_value   * 
   */
  onSubmitHandler = e => {
    e.stopPropagation();
    e.preventDefault();

    // if (this.state.searchOption.search_key === 'free-text') {
    //   ReactGA.event({
    //     category: 'SearchByKeyword',
    //     action: 'Click',
    //     label: `${this.state.searchOption.search_value}`
    //   });      
    // }

    if (e.target.dataset.name === 'catSearchBtn') {
      
      if (this.state.searchOption.category_search !== "") {
        let searchKey = this.state.CATEGORY_KEY;
        let searchValue  = this.state.searchOption.category_search

        let searchValuek = Object.keys(searchValue)
        let data = ''
        let slugs = []
        let catnames = []
        for(let j = -1; j<(searchValuek.length - 1); j++) {
         data = searchValue[j]
         slugs.push(data.slug)
         catnames.push(data.catname)
        }
        searchValue = slugs.join(' ')
        let category_names = catnames.join(', ')

        defaultState.searchReducer.searchOption = Object.assign(defaultState.searchReducer.searchOption, { search_key: searchKey, search_value: searchValue, category_names: category_names });

        let selectedValue = this.state.subCategories[0].selectedKey;

        this.state.subCategories.forEach((cat, index) => {
          selectedValue = `${selectedValue} / ${cat.selectedValue}`;
        })

        defaultState.searchReducer.selectedEventSearchOption = selectedValue;

        this.props.saveSearchOption(defaultState.searchReducer.searchOption);

        this.setState({
          searchOption: { ...this.state.searchOption, search_key: searchKey, search_value: searchValue, category_names: category_names }
        });

        this.props.history.push({
          pathname: '/troublesht/articles',
          state: { searchOption: { search_key: searchKey, search_value: searchValue, category_names: category_names } }
        });
      }
      // let selectedValue = this.state.subCategories[0].selectedKey;

      // this.state.subCategories.forEach((cat, index) => {
      //   selectedValue = `${selectedValue} / ${cat.selectedValue}`;
      // })

      // ReactGA.event({
      //   category: 'SearchByCategory',
      //   action: 'Click',
      //   label: selectedValue
      // });

    } else if (e.target.dataset.name === 'freeTextSearchBtn') {

      //if(this.state.searchOption.keyword_search !="" ){    
        let searchKey = this.state.FREETEXT_KEY;
        let searchValue  = this.state.searchOption.keyword_search;
      defaultState.searchReducer.searchOption = Object.assign(defaultState.searchReducer.searchOption, { search_key: searchKey, search_value: searchValue });

      this.props.saveSearchOption(defaultState.searchReducer.searchOption);

      this.setState({
        searchOption: { ...this.state.searchOption, search_key: searchKey, search_value: searchValue }
      });
      this.props.history.push({
        pathname: '/troublesht/articles',
        state: { searchOption: { search_key: searchKey, search_value: searchValue } }
      })
    }

  }


  /**
   * @render to load the view file
   */
  render() {

    console.log(this.state.searchOption);
    
    return (
      <SearchArticleComponent pageData={this.props.pageData.data} disableSearchBtn={this.state.disableSearchBtn} changeEvent={this.itemClick} submitEvent={this.onSubmitHandler} searchOption={this.state.searchOption} subCategories={this.state.subCategories} mainCategory={this.mainCategory} focusEvent={this.focusEvent} blurEvent={this.blurEvent} searchPlaceHolder={this.state.searchPlaceHolder} searchPage='main'/>
    );
  }

    /**
     * blurEvent
     */
    blurEvent = () => {
      this.setState({
        searchPlaceHolder: 'default'
      })
    }

  /**
   * focusEvent
   */
  focusEvent = () => {
    this.setState({
      searchPlaceHolder: ''
    })
  }


  /** New Dropdown click */
  itemClick = (e) => {
    let eventSelectValue = ''
    if(e.target.dataset.name === this.state.CATEGORY_KEY){
      e.target.value = e.target.dataset.value;
      e.target.name = e.target.dataset.name;
    }

    if (e.target.value && e.target.name === this.state.CATEGORY_KEY) {

      let children = (e.target.dataset.children) ? JSON.parse(e.target.dataset.children) : '';

      if (e.target.dataset && e.target.dataset.selectindex) {
        this.subCat[e.target.dataset.selectindex].selectedValue = e.target.value;
      }

      if (children) {
        
        if (e.target.dataset.catelevel === "main") {
          this.mainCategory = e.target.value;
          // console.log(this.mainCategory,'this.mainCategory')

          this.firstSelectedDropDownValue = e.target.value;
          ReactGA.event('Select-1',{
            category: 'Category',
            action: `Select-1`,
            event_category: 'Category',
            event_action: `Select-1`,
            event_label: this.firstSelectedDropDownValue,
            UserID: (this.props.auth.auth.userId) ?  this.props.auth.auth.userId : 'noAuth'
          });

          this.subCat = [];
        }
        this.SubCateList[e.target.dataset.slug] =  {
          "options": children,
          "selectedValue": '',
          selectedKey: ''
        };
       
        const isExistObject = this.subCat.some(el => el.selectedKey ===  e.target.dataset.slug);
        if(e.target.dataset.selectindex && !isExistObject){
          this.subCat = this.subCat.slice(0, parseInt(e.target.dataset.selectindex) + 1);  
        }
        

        if (!isExistObject) {
          this.subCat.push({
            "options": children,
            "selectedValue": '',
            "selectedKey" : e.target.dataset.slug
          });
        }

        eventSelectValue = this.firstSelectedDropDownValue

        this.subCat.forEach((cat)=> {
          if (cat.selectedValue !== '') {
            eventSelectValue = `${eventSelectValue} / ${cat.selectedValue}`
          }
        })

        if (e.target.dataset.selectindex) {
          ReactGA.event(`Select-${parseInt(e.target.dataset.selectindex) + 2}`,{
            category: 'Category',
            action: `Select-${parseInt(e.target.dataset.selectindex) + 2}`,
            event_category: 'Category',
            event_action: `Select-${parseInt(e.target.dataset.selectindex) + 2}`,
            event_label: `${eventSelectValue}`,
            UserID: (this.props.auth.auth.userId) ?  this.props.auth.auth.userId : 'noAuth'
          });
        }

        this.setState({
          subCategories: this.subCat,
          disableSearchBtn: true
        })

      } else {

        this.subCat = this.subCat.slice(0, parseInt(e.target.dataset.selectindex) + 1);

        eventSelectValue = this.firstSelectedDropDownValue
        this.subCat.forEach(cat => {
          eventSelectValue = `${eventSelectValue} / ${cat.selectedValue}`
        })

        ReactGA.event(`Select-${this.subCat.length + 1}`,{
          category: 'Category',
          action: `Select-${this.subCat.length + 1}`,
          event_category: 'Category',
          event_action: `Select-${this.subCat.length + 1}`,
          event_label: `${eventSelectValue}`,
          UserID: (this.props.auth.auth.userId) ?  this.props.auth.auth.userId : 'noAuth'
        });

        this.setState({
          subCategories: this.subCat,
          disableSearchBtn: false
        })

      }

      let indexd  = e.target.dataset.indexc;
      let slug    = e.target.dataset.slug;
      let haschild = e.target.dataset.children;
      let catName  = e.target.value

      const cmp = {}
      if(haschild) {
        cmp[e.target.dataset.indexc] = 'yes'
      } else if(haschild === undefined) {
        cmp[e.target.dataset.indexc] = 'no'
      }
    
      let cmpkey =  parseInt(Object.keys(cmp).join());
      let cmpval =  Object.values(cmp).join();
      const prevstate = this.state.searchOption.category_search
      if(prevstate) {
         
        if(cmpval === 'no') {
          
          cmpkey = cmpkey + 1;

          let prevstateKeys = Object.keys(prevstate)

           for(let i = cmpkey; i<prevstateKeys.length; i++) {

              if(i in prevstate) {
                Reflect.deleteProperty(prevstate, i);
              } 

           }
          
        }

      }

      this.setState({
        searchOption: { ...this.state.searchOption, category_search: {...prevstate, [indexd] : {"slug" : slug, "catname" : catName} }, search_value: {...prevstate, [indexd] : {slug, catName} }, search_key: e.target.name, category_names: "" }

      });
      

    } else if (e.target.value && e.target.name === this.state.FREETEXT_KEY) {

      this.setState({        
        //disableSearchBtn: true,
        searchOption: { ...this.state.searchOption, keyword_search: e.target.value, search_value: e.target.value, search_key: e.target.name }
      });

    } else {

      /* if (e.target.dataset && e.target.dataset.selectindex) {

        this.subCat[e.target.dataset.selectindex].selectedValue = '';
      }
      this.selectedCat = this.selectedCat.slice(0, parseInt(e.target.dataset.selectindex) + 1);
      this.subCat = this.subCat.slice(0, parseInt(e.target.dataset.selectindex) + 1);

        */
      

      this.setState({ 
        subCategories: ( e.target.name === this.state.CATEGORY_KEY && e.target.dataset.catelevel === "main") ? [] : this.subCat,
        searchOption: {
          ...this.state.searchOption,
          keyword_search: (e.target.name === this.state.FREETEXT_KEY) ? "" : this.state.searchOption.keyword_search,
          category_search: (e.target.name === this.state.CATEGORY_KEY) ? "" : this.state.searchOption.category_search          
        }
      });
    }

  }

}


/** @mapDispatchToProps
 *  dispatch method to props  
 */

const mapDispatchToProps = {
  getPageData: getPageDataAction,
  saveSearchOption: saveSearchOptionAction
};

/** @mapStateToProps
 *  map state to props  
 */

const mapStateToProps = (state) => ({
  pageData: state.searchReducer.pageData,
  searchOption: state.searchReducer.searchOption,
  auth: state.auth
})


export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchArticleContainer);